export const KYC_USAGE_STATS_REQUEST = 'KYC_USAGE_STATS_REQUEST';
export const KYC_USAGE_STATS_RESPONSE = 'KYC_USAGE_STATS_RESPONSE';

export const kycUsageStatsRequest = (data) => {
    return {
        type: KYC_USAGE_STATS_REQUEST,
        data
    }
}
export const kycUsageStatsResponse = (data) => {
    return {
        type: KYC_USAGE_STATS_RESPONSE,
        data
    }
}

export const KYC_USAGE_METERING_REQUEST = 'KYC_USAGE_METERING_REQUEST';
export const KYC_USAGE_METERING_RESPONSE = 'KYC_USAGE_METERING_RESPONSE';

export const kycUsageMeteringRequest = (data) => {
    return {
        type: KYC_USAGE_METERING_REQUEST,
        data
    }
}
export const kycUsageMeteringResponse = (data) => {
    return {
        type: KYC_USAGE_METERING_RESPONSE,
        data
    }
}


export const DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE = 'Download_Kyc_Pricing_Request_Template';
export const DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE_SUCCESS = 'Download_Kyc_Pricing_Request_Template_Success';
export const DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE_FAILURE = 'Download_Kyc_Pricing_Request_Template_Failure';
export const downloadKycPricingRequestTemplate = (data) => {
    return {
        type: DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE,
        data
    }
}
export const downloadKycPricingRequestTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadKycPricingRequestTemplateFailure = (error) => {
    return {
        type: DOWNLOAD_KYC_PRICING_REQUEST_TEMPLATE_FAILURE,
        error
    }
}

export const SUBMIT_KYC_PRICING_REQUEST = 'Submit_Kyc_Pricing_Request';
export const SUBMIT_KYC_PRICING_REQUEST_SUCCESS = 'Submit_Kyc_Pricing_Request_Success';
export const SUBMIT_KYC_PRICING_REQUEST_FAILURE = 'Submit_Kyc_Pricing_Request_Failure';
export const submitKycPricingRequest = (data) => {
    return {
        type: SUBMIT_KYC_PRICING_REQUEST,
        data
    }
}
export const submitKycPricingRequestSuccess = (data) => {
    return {
        type: SUBMIT_KYC_PRICING_REQUEST_SUCCESS,
        data
    }
}
export const submitKycPricingRequestFailure = (error) => {
    return {
        type: SUBMIT_KYC_PRICING_REQUEST_FAILURE,
        error
    }
}


//KYC API USAGE 
export const KYC_API_USAGE_STATS_REQUEST = 'KYC_API_USAGE_STATS_REQUEST';
export const KYC_API_USAGE_STATS_RESPONSE = 'KYC_API_USAGE_STATS_RESPONSE';

export const kycApiUsageStatsRequest = (data) => {
    return {
        type: KYC_API_USAGE_STATS_REQUEST,
        data
    }
}

export const kycApiUsageStatsResponse = (data) => {
    return {
        type: KYC_API_USAGE_STATS_RESPONSE,
        data
    }
}